import React from 'react';
import styled from 'styled-components';
import Link from '@com/core/common/components/Link';
import { breakpoints } from '@com/core/common/styles/baseStyles';

type TProps = {
    data: {
        titleText?: string;
        titleImageUrl?: string;
        linkText?: string;
        linkUrl?: string;
        linkBgColor?: string;
        titleColor?: string;
    };
    textColor?: string;
    className?: string;
};

const commonSpace = 12;

const ModuleHeaderContainer = styled.div<TLinkProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-direction: column;
    @media ${breakpoints.minTablet} {
        flex-direction: row;
    }

    .borderStart,
    .borderEnd {
        display: none;
        height: 5px;
        background-size: 10px 5px;
        background-image: linear-gradient(to left, #2496b7 50%, transparent 50%);
        flex: 1;
    }
    .borderStart {
        ${({ theme: { isRTL } }): string => (isRTL ? 'margin-left: 15px' : 'margin-right: 15px')};
        background-position: ${({ theme: { isRTL } }): string => (isRTL ? 'left center' : 'right center')};
        @media ${breakpoints.minTablet} {
            display: block;
        }
    }
    .borderEnd {
        ${({ theme: { isRTL } }): string => (isRTL ? 'margin-right: 15px' : 'margin-left: 15px')};
        background-position: ${({ theme: { isRTL } }): string => (isRTL ? 'right center' : 'left center')};
        @media ${breakpoints.minTablet} {
            display: block;
        }
    }

    .LinkCover {
        font-weight: bold;
        color: ${({ textColor, theme: { colors } }): string => textColor || colors.brandSecondary};
        font-size: 1rem;
        line-height: 1rem;
        text-transform: uppercase;
        letter-spacing: 0.2px;
        padding: ${commonSpace / 2}px ${commonSpace}px;
        border: 2px solid;
        background-color: ${({ linkBgColor, theme: { colors } }): string => linkBgColor || colors.bgPrimary};

        display: flex;
        justify-content: center;
        align-items: center;
        &::after {
            content: '';
            border-style: solid;
            border-width: 0 2px 2px 0;
            border-color: ${({ textColor, theme: { colors } }): string => textColor || colors.brandSecondary};
            display: inline-block;
            padding: 2px;
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            margin: 0 ${commonSpace / 2}px;
        }
        @media ${breakpoints.minTablet} {
            position: absolute;
            right: ${commonSpace * 5}px;
        }
    }
`;

const Title = styled.h3`
    font-weight: bold;
    font-size: 1.8rem;
    color: #ff5c35;
    text-transform: uppercase;
    text-align: center;
    @media ${breakpoints.minTablet} {
        font-size: 2rem;
    }
`;

type TLinkProps = {
    textColor?: string;
    linkBgColor?: string;
};

const ModuleHeaderDotted = ({ className, data, textColor }: TProps): JSX.Element => {
    return (
        <ModuleHeaderContainer
            className={className}
            textColor={textColor}
            linkBgColor={data.linkBgColor}
            style={{ padding: !data.titleText && !data.linkText ? '0' : `${commonSpace}px ${commonSpace * 2}px` }}>
            {data.titleText && (
                <>
                    <span className="borderStart" />
                    <Title style={{ color: data.titleColor }}>{data.titleText}</Title>
                    <span className="borderEnd" />
                </>
            )}

            {data.linkText && (
                <Link href={`${data.linkUrl}`} linkClass="LinkCover">
                    {data.linkText}
                </Link>
            )}
        </ModuleHeaderContainer>
    );
};

export default ModuleHeaderDotted;
